import { useAuth } from "../../context/AuthContext";
import { getBrandAssets } from "./brand.config";

export function useBranding() {
  const { isPremium } = useAuth();
  const assets = getBrandAssets(isPremium);

  return assets;
}
